import { useScaffold } from "@Light/utils/context";
import { ArrowLeft } from "@untitledui/icons";
import clsx from "clsx";
import React from "react";
import { OnBack } from "./context";

export type BackButtonProps = {
  onBack: OnBack | undefined;
};

export const BackButton: React.FC<BackButtonProps> = ({
  onBack,
}: BackButtonProps) => {
  const scaffold = useScaffold();

  if (!onBack) {
    return <div className="w-10 h-10" />;
  }

  return (
    <button data-testid="back-button" onClick={onBack}>
      <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white">
        <ArrowLeft
          className={clsx(
            "w-6 h-6 cursor-pointer",
            scaffold.page.colors.text.primary,
          )}
        />
      </div>
    </button>
  );
};
